import React, { FunctionComponent, useEffect } from 'react';
import { Layout } from 'tea-component';
import qs from 'qs';
import { CommonDashboardReport } from '@home/components/CommonDashboardReport';
import { buriedPointPage } from '@home/utils/buriedPoint';
const { Content } = Layout;
interface Props {
  dashboardId: string;
  system: string;
}

const EmbeddedReportPage: FunctionComponent<Props> = () => {
  const params: any = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  
  useEffect(() => {
    buriedPointPage({
      pageId: '601801',
      pageName: 'embedded',
      extInfo: '',
      pagePath: '/embedded',
      typeId: 'datalab_pc_v2',
    });
  }, []);
  
  if (!params.dashboardId) {
    console.log('外嵌报表页面参数错误, 请调用方正确传入报表id');
    return null;
  }
  return (
    <Content.Body full>
      <CommonDashboardReport {...params} />
    </Content.Body>
  );
};

export default EmbeddedReportPage;
